<template>
  <div
    class="form-group"
    :class="{
      'input-group-focus': focused,
      'has-danger': error,
      'has-success': !error && touched,
      'has-label': label
  }">
    <div
      class="mb-0"
      :class="{'input-group': hasIcon}">
      <slot name="label">
        <label v-if="label"> {{ label }} {{ required ? '*' : '' }} </label>
      </slot>
      <slot name="addonLeft">
        <span
          v-if="addonLeftIcon"
          class="input-group-prepend">
          <div class="input-group-text"><i :class="addonLeftIcon" /></div>
        </span>
      </slot>
      <slot>
        <input
          v-focus="focus"
          :disabled="forceUnlock || disabled"
          :value="value"
          v-bind="$attrs"
          v-on="listeners"
          class="form-control"
          aria-describedby="addon-right addon-left">
      </slot>
      <slot name="unlock">
        <base-button
          @click="forceUnlock = false"
          v-if="forceUnlock"
          link
          type="primary"
          class="unlock-field-btn">
          Edit
        </base-button>
      </slot>
    </div>

    <slot
      name="error"
      v-if="error || $slots.error">
      <label class="error">{{ error }}</label>
    </slot>

    <slot name="addonRight">
      <span
        v-if="addonRightIcon"
        class="input-group-append">
        <div class="input-group-text"><i :class="addonRightIcon" /></div>
      </span>
    </slot>
    <slot name="helperText" />
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'BaseInput',
  props: {
    required: Boolean,
    label: {
      type: String,
      description: 'Input label',
    },
    focus: {
      type: Boolean,
      default: false,
      description: 'Autofocus this field',
    },
    error: {
      type: String,
      description: 'Input error',
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    unlock: {
      type: Boolean,
      default: false,
      description: 'Force user to unlock input to edit it',
    },
    value: {
      type: [String, Number],
      description: 'Input value',
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right',
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left',
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  data() {
    return {
      forceUnlock: false,
      focused: false,
      touched: false,
    };
  },
  created() {
    this.forceUnlock = this.unlock;
  },
  computed: {
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined
        || addonLeft !== undefined
        || this.addonRightIcon !== undefined
        || this.addonLeftIcon !== undefined
      );
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus,
      };
    },
  },
  methods: {
    onInput(evt) {
      if (!this.touched) {
        this.touched = true;
      }
      this.$emit('input', evt.target.value);
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
  },
};
</script>
